import { C, sans, mono, type, space, border } from "../theme.ts";

/** One row in the "more" menu sheet: a label and, in mono, what it is. */
export function MenuItem({
  label, note, active, onClick, icon, noBorder,
}: {
  label: string; note: string; active: boolean; onClick: () => void;
  /** Lock's icon — the one row in the list that carries one. */
  icon?: React.ReactNode;
  /** Ask AI and Lock sit outside the row-by-row rhythm, set apart by their
   * own divider instead of the hairline every ordinary row draws under
   * itself. */
  noBorder?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex", alignItems: "center", gap: space.md,
        width: "100%", textAlign: "left", background: "none",
        border: "none", borderBottom: noBorder ? "none" : `${border.hairline}px solid ${C.rule}`,
        padding: `${space.lg}px ${space.xxs}px`, cursor: "pointer", fontFamily: sans,
      }}
    >
      {icon}
      <span>
        <span style={{ fontSize: type.lead, color: C.ink, fontWeight: active ? 600 : 400 }}>{label}</span>
        <span style={{ fontFamily: mono, fontSize: type.small, color: C.inkFaint, marginLeft: space.md }}>{note}</span>
      </span>
    </button>
  );
}
